import { styled, Box, Button, Typography, alpha } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CONTAINER_FIELDS_FLOATING,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  DARK_TEXT,
  DARK_PROGRESS_OVERLAY_BACKGROUND,
  LIGHT_TEXT,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  LIGHT_HEADER_LINE,
  DARK_FIELDS_FLOATING_BUTTON_BACKGROUND,
  LIGHT_FIELDS_FLOATING_BUTTON_BACKGROUND,
  LIGHT_PROGRESS_OVERLAY_BACKGROUND,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_CONTAINER_BORDER,
  PRIMARY_ICON,
} = COLORS;

import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    circle: {
      stroke: 'url(#linearColors)',
      position: 'absolute',
    },
    imgContainer: {
      position: 'relative',
      width: 101,
      height: 139,
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: PRIMARY_CONTAINER_BORDER,
      borderRadius: '8px !important',
      marginRight: 20,
      marginLeft: 20,
      '&:hover': {
        '& .camera-cont': {
          opacity: 1,
        },
      },
    },
    img: {
      width: '92%',
      height: '94%',
      position: 'absolute',
      left: '50%',
      top: 6,
      transform: 'translate(-50%, 0)',
      borderRadius: 5,
      cursor: 'pointer',
    },
  }),
);

export const MainCont = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  margin: '0 0 20px 0',
}));

export const ButtonCont = styled(Box)(() => ({
  marginTop: 20,
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  width: '100%',
  minHeight: 74,
  fontWeight: 500,
  borderRadius: 8,
  backgroundColor:
    theme.palette.type === 'dark' ? DARK_FIELDS_FLOATING_BUTTON_BACKGROUND : LIGHT_FIELDS_FLOATING_BUTTON_BACKGROUND,
  display: 'flex',
  justifyContent: 'start',
  fontSize: 18,
  padding: '12px 30px 12px',
  textAlign: 'left',

  '& svg': {
    height: 30,
    width: 'auto',
    marginRight: 10,
  },
}));

export const ActionButtonTwoRowLabel = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginTop: -5,

  '& .MuiButton-label > div': {
    whiteSpace: 'normal',
  },
}));

export const MeCont = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 182,
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  borderStyle: 'solid',
  borderWidth: 2,
  borderColor: PRIMARY_CONTAINER_BORDER,
  borderRadius: '8px !important',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  '& > div:first-child': {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down(960)]: {
      flexDirection: 'column',
    },
  },

  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
    height: 'unset',
    alignItems: 'center',
    justifyContent: 'unset',

    '& > div': {
      width: '100%',
      '&:first-child': {
        marginTop: 30,
        width: '100%',
      },

      '&:last-child': {
        margin: '20px 0',
        width: '100%',
      },
    },
  },
}));

export const MiniFlexContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4em',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: '1em',
  },

  '& > div': {
    width: '100%',
    '&:first-child': {
      display: 'flex',
      gap: 20,
      alignItems: 'center',
      flexWrap: 'nowrap',
    },
  },
}));

export const ManageButton = styled(Button)(({ theme }) => ({
  background: 'transparent',
  border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
  height: 36,
  minWidth: 172,
  marginLeft: 80,
  [theme.breakpoints.down(960)]: {
    marginLeft: 0,
  },
}));

export const TempPlanIcon = styled('img')(() => ({
  height: 40,
  width: 40,
}));

export const MyPic = styled('img')(({ theme }) => ({
  width: 115,
  height: 150,
  objectFit: 'cover',
  objectPosition: 'top',
  borderRadius: 8,
  [theme.breakpoints.down('xs')]: {
    width: 180,
    height: 180,
  },
}));

export const WelcomeCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.down(960)]: {
    alignSelf: 'center',
    alignItems: 'center',
  },
}));

export const WelcomeHeading = styled(Typography)(({ theme }) => ({
  fontSize: 25,
  fontWeight: 500,
  textTransform: 'capitalize',
  [theme.breakpoints.down(960)]: {
    textAlign: 'center',
  },
}));
export const GuardianHeading = styled(Typography)(({ theme }) => ({
  color: theme.palette.type === 'dark' ? LIGHT_TEXT : DARK_TEXT,
  marginTop: -5,
  [theme.breakpoints.down(960)]: {
    textAlign: 'center',
  },
}));

export const WelcomeSub = styled(Typography)(() => ({
  fontSize: 16,
  color: DARK_TEXT,
}));

export const FlexContainer = styled('div')(({ theme }) => ({
  marginTop: 25,
  display: 'flex',
  gap: 25,
  [theme.breakpoints.down(1600)]: {
    flexDirection: 'column',
    '& > button': {
      width: '100%',
    },
  },
}));

export const CardContainer = styled('div')(({ theme }) => ({
  width: '100%',
  background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  borderRadius: 8,
  padding: 20,
  height: 'fit-content',
  minHeight: 310,
}));

export const CardHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  gap: 15,
  marginBottom: 15,
  paddingBottom: 15,
  justifyContent: 'space-between',

  '&::before': {
    content: '""',
    background: theme.palette.type === 'dark' ? DARK_FIELDS_ON_CARD_HEADER_LINE : LIGHT_HEADER_LINE,
    height: '1px',
    position: 'absolute',
    width: '102%',
    marginLeft: '-1%',
    bottom: '-1px',
  },

  '& svg': {
    height: 30,
    width: 'auto',
  },

  '& .profile-icon path': {
    fill: PRIMARY_ICON,
  },

  '& > div:first-child': {
    display: 'flex',
    gap: 15,
  },

  '& a': {
    textDecoration: 'none',

    '&:hover': {
      opacity: 0.8,
    },
  },
}));

export const CardItem = styled('div')(() => ({
  textAlign: 'center',
}));

export const EmptyContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 5,
  width: '100%',
  height: 84.78,
}));

export const ProgressOverlay = styled(Box)(({ theme }) => ({
  backgroundColor:
    theme.palette.type === 'dark'
      ? alpha(DARK_PROGRESS_OVERLAY_BACKGROUND, 0.6)
      : alpha(LIGHT_PROGRESS_OVERLAY_BACKGROUND, 0.6),
  position: 'absolute',
  left: 26,
  top: 5,
  width: 'calc(100% - 53px)',
  height: 'calc(100% - 10px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 99,
  borderRadius: 5,
}));

export const CameraCont = styled(Box)(() => ({
  position: 'absolute',
  bottom: 0,
  opacity: 0,
  width: '100%',
  transition: '100ms',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 10,
}));

export const PlanCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginRight: 40,
  alignItems: 'center',
  [theme.breakpoints.down(960)]: {
    gap: 20,
    flexDirection: 'column',
  },
}));

export const PlanText = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 20,
}));
